// usePrerenderReady.js — signals to core/prerender.py's headless-Chromium
// renderer that a page's real content has settled and it's safe to capture
// page.content() for a static HTML snapshot. Mirrors the exact pattern
// ReportPage.vue already uses for PDF export (`data-pdf-ready`,
// core/pdf_export_browser.py) — same mechanism, different consumer.
//
// Most pages need no changes: App.vue fires this automatically once
// mounted, since their content is already in the DOM synchronously (no
// async data fetch gates what's visible). Only pages that fetch data
// AFTER mount and render different content once it arrives (LearnPage.vue,
// ArticlePage.vue) need to opt out of the automatic fire (see
// AUTO_FIRE_EXCLUDED_ROUTES below) and call markPrerenderReady() themselves
// once their fetch resolves — otherwise the prerender snapshot would
// capture the loading skeleton instead of the real content.

const READY_ATTR = 'data-prerender-ready';
let fired = false;

export function markPrerenderReady() {
  if (fired) return;
  fired = true;
  // Marker element rather than an attribute on <body> directly — avoids
  // any risk of colliding with a real attribute a future change might add
  // to <body>, and matches the existing data-pdf-ready pattern's own
  // preference for a dedicated, inert marker node.
  const el = document.createElement('div');
  el.setAttribute(READY_ATTR, 'true');
  el.style.display = 'none';
  document.body.appendChild(el);
}

// Routes whose content depends on an async fetch completing — App.vue skips
// its automatic fire for these; the page itself must call
// markPrerenderReady() once real content (not a loading skeleton) is shown.
export const PRERENDER_ASYNC_ROUTES = new Set(['learn', 'article']);
